
import {of,  Observable } from 'rxjs';

import { catchError, tap } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { LoaderService } from "../../common/services/loader.service";
import { ApplicationsService } from "../services/applications.service";
import { InitiateWorkflowRequest, ApplicationType, WorkflowData } from "../models/applications.models";


@Injectable()
export class ApplicationsResolver  {
    constructor(public readonly loaderService: LoaderService, private auth: AuthService, private applicationsService: ApplicationsService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : any | Observable<any> | Promise<any> {
        this.loaderService.toggleLoader(true);
        let urlParts = state.url.split('/');
        let applicationType: string;
        if (urlParts.length > 2) {
			if (urlParts[2] === "stratigraphic") applicationType = ApplicationType.Stratigraphic; //probably needs some reworking as this is really only needed for new applictions
			else if (urlParts[2].includes("bulk-nad83")) applicationType = ApplicationType.BulkNAD83Update;
        }
        let id: any = route.params.id;
        let obs$: Observable<WorkflowData> = of(null);
        switch (applicationType) {
            case ApplicationType.Stratigraphic:
                obs$ = id == "new" || id == null
                    ? this.applicationsService.initiateApplication(this._buildRequest(applicationType))
                    : this.applicationsService.getApplicationByApplicationNumber(id);
				break;
			case ApplicationType.BulkNAD83Update:
				obs$ = this.applicationsService.getApplicationByApplicationNumber(id);
				break;
        }
        return obs$.pipe(catchError((err) => this.handleError(err)), tap((data) => { this.loaderService.toggleLoader(false); }));
    }

    handleError(error: any): Observable<any> {
        return of(error).pipe(tap((data) => {
            console.error(error);
            this.loaderService.toggleLoader(false);
        }));
    }

    private _buildRequest(type: ApplicationType): InitiateWorkflowRequest {
        return {
            organizationId: this.auth.User.organizationId,
            applicationType: type
        } as InitiateWorkflowRequest;
    }
}